import { render, staticRenderFns } from "./carga.vue?vue&type=template&id=548edc35&scoped=true"
import script from "./carga.vue?vue&type=script&lang=js"
export * from "./carga.vue?vue&type=script&lang=js"
import style0 from "./carga.vue?vue&type=style&index=0&id=548edc35&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548edc35",
  null
  
)

export default component.exports